export function duplicateContractDraft(source, candidate) {
  return {
    contractType: ["interim", "cdd", "cdi", "vacation"].includes(
      source.contractType,
    )
      ? source.contractType
      : "interim",
    candidate,
    startDate: null,
    endDate: null,
    startHour: null,
    endHour: null,
    address: source.AdresseRue || "",
    postCode: source.AdresseCodePostal || "",
    town: source.AdresseVille || "",
    clientQualification: {
      IdQualification: source.IdQualification || "",
      TxtQualification: source.TxtQualification || source.Qualification || "",
    },
  };
}
